module.exports = __webpack_public_path__ + "static/favicon-c8a2bfc71cb9794da2327cac5e0fd974.ico";